// src/frontend/pages/pdfCertificado.jsx
"use client";

/* eslint-disable no-console */

import React, { useEffect, useMemo, useState } from "react";
import { ethers } from "ethers";

// ====== MAPAS (ajusta rutas si difieren) ======
import MAP_180 from "../data/maps/mapa_nombres_180_pngs.json";
import MAP_272 from "../data/maps/mapa_nombres_272_pngs.json";
import MAP_510 from "../data/maps/mapa_nombres_510_pngs.json";
import MAP_1736_688 from "../data/maps/mapa_nombres_1736_688_pngs.json";
import MAP_1736_1048 from "../data/maps/mapa_nombres_1736_1048_pngs.json";
import MAP_3264 from "../data/maps/mapa_nombres_3264_pngs.json";
import MAP_special from "../data/maps/mapa_nombres_special_pngs.json";

// ====== CONTRATO (debe exponer mintImage(address to, string tokenURI) payable) ======
import UvegCertificateNft from "../contractsData/UvegCertificateNft.json";
const CONTRACT_ADDRESS = "0xaEbBB2C766b0927C870cfb7c024C0e9623e6d08C";

// ====== Lotes → CIDs (PNG/JSON) ======
const LOTES = {
  "180": {
    PNG: "Qma5LbMxLEr9YtCx6vrywj28aQmkaMAPiRrCwuwFaC7Vqo",
    JSON_CID: "QmVFfSvdNk5Nmjenkzf9aCYnRhhvdjeYmyK27AXHqZktUa",
  },
  "272": {
    PNG: "QmddAZwBnep81er7LuytezpLuD8vFLNw2hcX38QGgU4ySQ",
    JSON_CID: "QmXWJH3zivw238SCbWVpgK1zy1w1ZjpH6iPGzLMsArdsUG",
  },
  "510": {
    PNG: "QmWX5GnL9ki42RKQhjRqugEpeVLf27F1TC6NiH3BizJ6hg",
    JSON_CID: "QmVU9pUHPLUoPMTyZzTZpvFxNvqbyiQ8L48mJzoPGia68b",
  },
  "1736_688": {
    PNG: "QmQmTGwAaFNYjNvn2jMdudZndoevRwDR71XM9ZN18eezT4",
    JSON_CID: "QmdTgpDE2rh1z4xazpJqSNcdz9Dq9bhFhRAjfDVJKgbcHh",
  },
  // ── Subcarpetas dentro del MISMO CID (1-1000 / 1001-1048)
  "1736_1048": {
    PNG: "QmQ1wYw73qbn6ZQrexMFMw8qAtywMAaTstHZqZo7uesYro",
    JSON_CID: "QmaBKfn5H3U7CMjas7UzfRDtpZTF7i8uevFoZup1z7iyjc",
  },

  // ── 3264: PNG con CIDs por carpeta (archivos planos N.png) + JSON único con subcarpetas
  "3264": {
    PNG_MULTI: {
      "1-1000":    "QmbniLSA35srq6kVphaH2KEPy3nt9YArC2tes9xJApUFw9", // ← reemplaza
      "1001-2000": "QmRe2SK355YhJMPLw5Ta8zFDZgFasFDLk8E8XmpGDdm1zr", // ← reemplaza
      "2001-3000": "QmZy9C5WPym5AK264DyB9DgLuUn9rAeRtP1P9dEAq7z8V5", // ← reemplaza
      "3001-3264": "QmatV6c7FFR8A6B23LG4NKSTv9JUMB7u3R2sDEBXGKnN96", // ← reemplaza
    },

    JSON_CID: "QmQxmtuGKjmWSUoKsXquo28RPzuKYu49Fq2sAp6hNwaP6X", // ← reemplaza (único)
  },

  
};

const GATEWAY_BASE = "https://ok-indigo-vole.myfilebase.com/ipfs";
// (opcional) gateway dedicado al lote 180 para JSON (solo UI)
const JSON_180_BASE =
  "https://ok-indigo-vole.myfilebase.com/ipfs/QmVFfSvdNk5Nmjenkzf9aCYnRhhvdjeYmyK27AXHqZktUa";

/* ===================== HELPERS ===================== */
function toGatewayUrl(cid, path) {
  return `${GATEWAY_BASE}/${cid}/${encodeURIComponent(path).replace(/%2F/g, "/")}`;
}
function stripExt(s) {
  return String(s || "").replace(/\.(png|json)\s*$/i, "");
}
function normalize(s) {
  return stripExt(s || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[.,;:_\-]/g, " ")
    .replace(/[^\w\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
function getNumberFromFilename(filename) {
  const m = String(filename || "").match(/(\d+)\.(png|json)$/i);
  return m ? parseInt(m[1], 10) : null;
}
function mergeMapsToItems(mapObj, batchId) {
  const keys = Object.keys(mapObj || {});
  return keys.map((key) => ({ display: stripExt(key), norm: normalize(key), key, batchId }));
}
function toFileName(student, ext, fallback) {
  const s = String(student || "").trim();
  const base = s
    ? s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w\s.-]/g, "").replace(/\s+/g, "_")
    : String(fallback || "certificado");
  return base + "." + (ext || "png");
}

// ——— Rango → subcarpeta (para quienes usan subcarpetas) ———
function subfolderFor(batchId, n) {
  if (batchId === "1736_1048") {
    return n <= 1000 ? "1-1000" : "1001-1048";
  }
  if (batchId === "3264") {
    if (n <= 1000) return "1-1000";
    if (n <= 2000) return "1001-2000";
    if (n <= 3000) return "2001-3000";
    return "3001-3264";
  }
  return "";
}

// ——— CID de PNG por rango (3264 multi-CID; 1736_1048 un CID) ———
function resolvePngCid(batchId, n) {
  const pack = LOTES[batchId] || {};
  if (pack.PNG_MULTI) {
    const sub = subfolderFor(batchId, n);
    return pack.PNG_MULTI[sub] || "";
  }
  return pack.PNG || "";
}

// ——— Rutas internas: PNG plano en 3264; subcarpetas en 1736_1048; plano en otros ———
function buildPngPath(batchId, n) {
  if (batchId === "1736_1048") {
    const sub = subfolderFor(batchId, n);
    return sub ? `${sub}/${n}.png` : `${n}.png`;
  }
  if (batchId === "3264") {
    return `${n}.png`; // ✅ plano dentro del CID de su rango
  }
  return `${n}.png`;
}
function buildJsonPath(batchId, n) {
  if (batchId === "1736_1048") {
    const sub = subfolderFor(batchId, n);
    return sub ? `${sub}/${n}.json` : `${n}.json`;
  }
  if (batchId === "3264") {
    const sub = subfolderFor(batchId, n);
    return sub ? `${sub}/${n}.json` : `${n}.json`; // ✅ JSON único con subcarpetas
  }
  return `${n}.json`;
}

// Descarga desde IPFS probando varios gateways
async function fetchIpfsBlob(cid, path) {
  if (!cid || !path) throw new Error("Falta CID o path");
  const encPath = encodeURIComponent(path).replace(/%2F/g, "/");
  const urls = [
    `${GATEWAY_BASE}/${cid}/${encPath}`,
    `https://cloudflare-ipfs.com/ipfs/${cid}/${encPath}`,
    `https://ipfs.io/ipfs/${cid}/${encPath}`,
    `https://gateway.pinata.cloud/ipfs/${cid}/${encPath}`,
  ];
  for (const u of urls) {
    try {
      const res = await fetch(u, { method: "GET", cache: "no-store" });
      if (!res.ok) continue;
      const blob = await res.blob();
      if (blob && blob.size > 0) return blob;
    } catch {
      // intenta siguiente gateway
    }
  }
  throw new Error("No se pudo descargar desde IPFS");
}

// --- Forzar/cambiar a Polygon (137) si hace falta ---
async function switchToPolygon() {
  if (!window?.ethereum) throw new Error("MetaMask no está disponible");
  try {
    await window.ethereum.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: "0x89" }], // 137 Polygon Mainnet
    });
  } catch (err) {
    if (err?.code === 4902) {
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: "0x89",
            chainName: "Polygon Mainnet",
            nativeCurrency: { name: "MATIC", symbol: "MATIC", decimals: 18 },
            rpcUrls: ["https://polygon-rpc.com/"],
            blockExplorerUrls: ["https://polygonscan.com/"],
          },
        ],
      });
    } else {
      throw err;
    }
  }
}

/* ===================== UI SUBCOMPONENTES ===================== */
function FieldRow({ label, value }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "180px 1fr",
        gap: 12,
        padding: "8px 0",
        borderBottom: "1px solid #e5e7eb",
      }}
    >
      <div style={{ color: "#374151", fontSize: 14 }}>{label}</div>
      <div style={{ color: "#111827", fontSize: 14 }}>{value || "—"}</div>
    </div>
  );
}

// ======= Botón Mint con validación de saldo (USD $10) =======
function MintPngButton({ pngCid, pngPath }) {
  const [busy, setBusy] = useState("");
  const [notice, setNotice] = useState(null); // {title, details}

  // === Ajusta el precio aquí ===
  const USD_PRICE = 10;

  // Chainlink (Polygon mainnet)
  const MATIC_USD_FEED = "0xAB594600376Ec9fD91F8e885dADF0CE036862dE0";
  const CHAINLINK_AGG_ABI = [
    "function latestRoundData() view returns (uint80,int256,uint256,uint256,uint80)",
    "function decimals() view returns (uint8)",
  ];

  // Helpers de moneda
  function fmtMatic(wei) {
    try { return Number(ethers.utils.formatEther(wei)).toFixed(6); } catch { return "0"; }
  }
  function fmtUsd(num) {
    try { return (Math.round(Number(num) * 100) / 100).toFixed(2); } catch { return "0.00"; }
  }

  async function getMaticUsdPrice(provider) {
    const feed = new ethers.Contract(MATIC_USD_FEED, CHAINLINK_AGG_ABI, provider);
    const [decimals, lrd] = await Promise.all([feed.decimals(), feed.latestRoundData()]);
    const answer = lrd[1]; // price with 'decimals' decimals
    if (!answer || answer.lte(0)) throw new Error("Precio del oráculo inválido");
    return { price: answer, decimals: Number(decimals) }; // USD por 1 MATIC
  }

  // Convierte USD→wei de MATIC con +1% buffer
  async function quoteWeiUsd(provider, usdAmount = USD_PRICE) {
    const { price, decimals } = await getMaticUsdPrice(provider);
    // wei = usd * 10^18 / (USD/MATIC)
    const usdCents = Math.round(usdAmount * 100);
    const num = ethers.BigNumber.from(usdCents)
      .mul(ethers.BigNumber.from(10).pow(decimals))
      .mul(ethers.BigNumber.from(10).pow(18))
      .div(100);
    let wei = num.div(price);
    wei = wei.mul(101).div(100); // +1% buffer
    return wei;
  }

  // Obtiene el precio MATIC→USD para mostrar equivalencias
  async function weiToUsd(provider, wei) {
    const { price, decimals } = await getMaticUsdPrice(provider);
    // USD = wei * (USD/MATIC) / 10^18
    const usd = Number(ethers.utils.formatEther(wei)) * Number(ethers.utils.formatUnits(price, decimals));
    return usd;
  }

  async function doMintPNG() {
    setNotice(null);
    try {
      if (!pngCid || !pngPath) return alert("Falta PNG a mintear");
      if (!window?.ethereum) return alert("MetaMask no detectado");

      setBusy("Conectando…");
      const provider0 = new ethers.providers.Web3Provider(window.ethereum);
      const accs = await provider0.listAccounts();
      if (!accs?.length) await provider0.send("eth_requestAccounts", []);

      setBusy("Red Polygon…");
      await switchToPolygon();

      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const net = await provider.getNetwork();
      if (Number(net.chainId) !== 137) throw new Error("No estás en Polygon (137)");

      const signer = provider.getSigner();
      const to = await signer.getAddress();

      const pngUri = `ipfs://${pngCid}/${pngPath}`;

      setBusy(`Cotizando $${USD_PRICE} USD…`);
      const valueWei = await quoteWeiUsd(provider, USD_PRICE);

      // Instancia contrato
      const ABI = Array.isArray(UvegCertificateNft?.abi)
        ? UvegCertificateNft.abi
        : Array.isArray(UvegCertificateNft)
        ? UvegCertificateNft
        : [];
      if (!ABI.length) throw new Error("ABI vacío/incorrecto en UvegCertificateNft.json");
      const nft = new ethers.Contract(CONTRACT_ADDRESS, ABI, signer);
      if (typeof nft.mintImage !== "function") throw new Error("mintImage() no existe en ese contrato");

      // ======= PRE-CHECK: saldo suficiente (valor + gas) =======
      setBusy("Revisando saldo…");
      const [balanceWei, gasPrice] = await Promise.all([
        provider.getBalance(to),
        provider.getGasPrice(),
      ]);

      let gasLimit;
      try {
        gasLimit = await nft.estimateGas.mintImage(to, pngUri, { value: valueWei });
      } catch {
        // fallback si falla el estimation
        gasLimit = ethers.BigNumber.from(250000);
      }

      const txCostWei = gasLimit.mul(gasPrice);
      const totalWei = valueWei.add(txCostWei);

      if (balanceWei.lt(totalWei)) {
        const needM = fmtMatic(totalWei);
        const haveM = fmtMatic(balanceWei);
        const shortM = fmtMatic(totalWei.sub(balanceWei));
        const [needU, haveU, shortU] = await Promise.all([
          weiToUsd(provider, totalWei),
          weiToUsd(provider, balanceWei),
          weiToUsd(provider, totalWei.sub(balanceWei)),
        ]);
        setBusy("");
        setNotice({
          title: "Saldo insuficiente",
          details:
            `Necesitas ~${needM} MATIC (≈ $${fmtUsd(needU)} USD).\n` +
            `Tienes ~${haveM} MATIC (≈ $${fmtUsd(haveU)} USD).\n` +
            `Faltan ~${shortM} MATIC (≈ $${fmtUsd(shortU)} USD).\n` +
            `Recarga tu wallet e intenta de nuevo.`,
        });
        return; // ← No intentamos enviar la tx para evitar el error RPC
      }

      // ======= Enviar mint =======
      setBusy("Firmando mint…");
      const tx = await nft.mintImage(to, pngUri, { value: valueWei });
      setBusy("Confirmando…");
      await tx.wait();

      setBusy("");
      setNotice({
        title: "✅ Mint completado",
        details: "Tu certificado fue minteado con éxito (tokenURI = PNG).",
      });
    } catch (e) {
      console.error(e);
      setBusy("");
      // Mapear errores comunes a mensajes claros
      const msg = (e?.reason || e?.data?.message || e?.message || "").toString();
      if (msg.toLowerCase().includes("insufficient funds")) {
        setNotice({
          title: "Saldo insuficiente",
          details:
            "No tienes fondos para cubrir el valor y/o el gas. Recarga MATIC e intenta de nuevo.",
        });
      } else if (e?.code === 4001) {
        setNotice({ title: "Operación cancelada", details: "Rechazaste la firma en MetaMask." });
      } else {
        setNotice({
          title: "Error al mintear",
          details:
            msg || "Ocurrió un error inesperado. Revisa tu conexión, red y que el contrato sea correcto.",
        });
      }
    }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 260 }}>
      <button
        onClick={doMintPNG}
        disabled={!!busy}
        style={{
          padding: "10px 16px",
          border: "1px solid #0ea5e9",
          background: "#0ea5e9",
          color: "#fff",
          cursor: "pointer",
          minWidth: 140,
        }}
        title={`Mintear certificado (≈ $${USD_PRICE} USD)`}
      >
        {busy || `Mint (≈ $${USD_PRICE} USD)`}
      </button>

      {notice ? (
        <div
          style={{
            whiteSpace: "pre-wrap",
            border: "1px solid #fee2e2",
            background: "#fef2f2",
            color: "#7f1d1d",
            padding: "10px 12px",
            fontSize: 13,
            borderRadius: 6,
          }}
        >
          <strong style={{ display: "block", marginBottom: 4 }}>{notice.title}</strong>
          {notice.details}
        </div>
      ) : null}
    </div>
  );
}

function NftCard(props) {
  const safeName = props.name || "Diploma — Nombre del Estudiante";
  const imageUrl =
    props.imageCid && props.imagePath ? toGatewayUrl(props.imageCid, props.imagePath) : "";
  const attrs = Array.isArray(props.attributes) ? props.attributes : [];

  return (
    <div style={{ border: "1px solid #e5e7eb", background: "#fff", padding: 16 }}>
      {/* Título + badge */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <h2 style={{ margin: 0, fontSize: 20, color: "#0f172a", fontWeight: 600 }}>{safeName}</h2>
        {props.badgeText ? (
          <span
            style={{
              border: "1px solid #e5e7eb",
              padding: "4px 8px",
              fontSize: 12,
              color: "#111827",
              background: "#fff",
            }}
          >
            {props.badgeText}
          </span>
        ) : null}
      </div>

      {/* ====== LAYOUT: izquierda imagen | derecha info + botones ====== */}
      <div
        style={{
          display: "flex",
          gap: 16,
          alignItems: "flex-start",
          flexWrap: "wrap",
        }}
      >
        {/* Izquierda: Imagen */}
        <div style={{ flex: "0 0 420px", maxWidth: "100%" }}>
          {imageUrl ? (
            <div style={{ border: "1px solid #e5e7eb", background: "#f8fafc", padding: 8, textAlign: "center" }}>
              <img src={imageUrl} alt={safeName} style={{ maxWidth: "100%", height: "auto" }} />
            </div>
          ) : null}
        </div>

        {/* Derecha: Info + acciones */}
        <div style={{ flex: "1 1 320px", minWidth: 300 }}>
          <div style={{ border: "1px solid #e5e7eb", padding: 12, background: "#fff" }}>
            {attrs.length > 0 ? (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 8 }}>
                {attrs.map((a, i) => (
                  <span
                    key={`attr-${i}`}
                    style={{
                      fontSize: 12,
                      border: "1px solid #173674",
                      padding: "4px 8px",
                      color: "#fff",
                      background: "#0A4C88",
                    }}
                  >
                    {a?.trait_type ? <strong style={{ marginRight: 4 }}>{a.trait_type}:</strong> : null}
                    {a?.value ? String(a.value) : "—"}
                  </span>
                ))}
              </div>
            ) : null}

            <FieldRow label="Estudiante" value={props.student || "—"} />
            <FieldRow label="Universidad" value={props.university || "—"} />
            <FieldRow label="Curso" value={props.course || "—"} />
            <FieldRow label="Fecha de emisión" value={props.issueMonth || "—"} />
            <FieldRow label="Horas" value={props.hours || "—"} />
            <FieldRow label="Lugar" value={props.location || "—"} />

            {props.description ? (
              <div style={{ marginTop: 10, color: "#111827", fontSize: 14, lineHeight: 1.5 }}>
                {props.description}
              </div>
            ) : null}
          </div>

          {/* Acciones alineadas a la derecha */}
          <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 12 }}>
            <button
              onClick={props.onDownloadPng}
              style={{
                padding: "10px 14px",
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#0f172a",
                cursor: "pointer",
                minWidth: 140,
              }}
              title="Descargar PNG del diploma"
            >
              Descargar PNG
            </button>

            {/* Botón Mint compacto */}
            {props.mintButton || null}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ===================== COMPONENTE PRINCIPAL ===================== */
export default function PdfCertificado() {
  const [mapsByBatch] = useState({
    "180": MAP_180 || {},
    "272": MAP_272 || {},
    "510": MAP_510 || {},
    "1736_688": MAP_1736_688 || {},
    "1736_1048": MAP_1736_1048 || {},
    "3264": MAP_3264 || {},
  });

  const [allNames, setAllNames] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const [q, setQ] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [suggestionsOpen, setSuggestionsOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [jsonErr, setJsonErr] = useState("");
  const [displayedMeta, setDisplayedMeta] = useState({
    name: "Diploma — Nombre del Estudiante",
    student_name: "—",
    university: "—",
    course: "—",
    issue_month: "—",
    hours: "—",
    location: "—",
    description: "",
    attributes: [],
  });

  // Construir índice de nombres
  useEffect(() => {
    const items = []
      .concat(mergeMapsToItems(mapsByBatch["180"], "180"))
      .concat(mergeMapsToItems(mapsByBatch["272"], "272"))
      .concat(mergeMapsToItems(mapsByBatch["510"], "510"))
      .concat(mergeMapsToItems(mapsByBatch["1736_688"], "1736_688"))
      .concat(mergeMapsToItems(mapsByBatch["1736_1048"], "1736_1048"))
      .concat(mergeMapsToItems(mapsByBatch["3264"], "3264"));

    items.sort((a, b) => a.norm.localeCompare(b.norm, "es", { sensitivity: "base" }));

    setAllNames(items);
    setLoaded(true);
  }, [mapsByBatch]);

  const nameIndex = useMemo(() => {
    const idx = new Map();
    (allNames || []).forEach((it) => {
      idx.set(it.norm, it);
    });
    return idx;
  }, [allNames]);

  const suggestions = useMemo(() => {
    const list = Array.isArray(allNames) ? allNames : [];
    const nq = normalize(q);
    if (!nq) return list.slice(0, 50);
    if (nq.length === 1) {
      const starts = list.filter((it) => it.norm.startsWith(nq));
      const extra = list.filter((it) => it.norm.includes(nq) && !it.norm.startsWith(nq));
      return starts.concat(extra).slice(0, 100);
    }
    return list.filter((it) => it.norm.includes(nq)).slice(0, 100);
  }, [q, allNames]);

  function handleBuscar() {
    setHasSearched(true);
    setJsonErr("");
    const nq = normalize(q);
    const exact = nameIndex.get(nq);
    if (exact) {
      setSelectedKey(exact.key);
      setSelectedBatch(exact.batchId);
      setSuggestionsOpen(false);
      return;
    }
    if (suggestions.length > 0) {
      setSelectedKey(suggestions[0].key);
      setSelectedBatch(suggestions[0].batchId);
      setSuggestionsOpen(false);
      return;
    }
    setSelectedKey("");
    setSelectedBatch("");
  }

  function onKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      handleBuscar();
    }
  }

  const derived = useMemo(() => {
    if (!selectedKey || !selectedBatch) return null;

    const mapObj = mapsByBatch[selectedBatch] || {};
    const filePNG = mapObj[selectedKey];
    if (!filePNG) return null;

    const n = getNumberFromFilename(filePNG);
    if (n == null) return null;

    // CID correcto (puede depender del rango) y rutas internas
    const pngCid  = resolvePngCid(selectedBatch, n);
    const jsonCid = (LOTES[selectedBatch] || {}).JSON_CID || "";

    const pngPath  = buildPngPath(selectedBatch, n);
    const jsonPath = buildJsonPath(selectedBatch, n);

    // URL visibles (gateway)
    const ipfsPNG = pngCid ? toGatewayUrl(pngCid, pngPath) : "";
    let jsonUrl = "";
    if (selectedBatch === "180" && JSON_180_BASE) {
      jsonUrl = `${JSON_180_BASE}/${n}.json`;
    } else if (jsonCid) {
      jsonUrl = toGatewayUrl(jsonCid, jsonPath);
    }

    return {
      n,
      lote: selectedBatch,
      showName: stripExt(selectedKey),
      pngPath, jsonPath,
      ipfsPNG, jsonUrl,
      badge: `#${n} · Lote ${selectedBatch}`,
      pngCid, jsonCid,
    };
  }, [selectedKey, selectedBatch, mapsByBatch]);

  // Carga (opcional) de metadatos JSON (UI)
  useEffect(() => {
    async function loadJson() {
      if (!derived || !derived.jsonUrl) {
        setDisplayedMeta((prev) => ({
          ...prev,
          name: "Diploma — " + (derived && derived.showName ? derived.showName : "Nombre del Estudiante"),
        }));
        return;
      }
      try {
        setJsonErr("");
        const res = await fetch(derived.jsonUrl, { cache: "no-store" });
        if (!res.ok) throw new Error("HTTP " + res.status);
        const data = await res.json();
        setDisplayedMeta({
          name: data?.name ? data.name : "Diploma — " + derived.showName,
          student_name: data?.student_name || "—",
          university: data?.university || "—",
          course: data?.course || "—",
          issue_month: data?.issue_month || "—",
          hours: data?.hours || "—",
          location: data?.location || "—",
          description: data?.description || "",
          attributes: Array.isArray(data?.attributes) ? data.attributes : [],
        });
      } catch {
        setJsonErr("No fue posible cargar los metadatos.");
        setDisplayedMeta((prev) => ({
          ...prev,
          name: "Diploma — " + (derived && derived.showName ? derived.showName : "Nombre del Estudiante"),
        }));
      }
    }
    loadJson();
  }, [derived]);

  async function downloadPng() {
    if (!derived || !derived.pngPath) return;
    const pngCid = derived.pngCid;
    if (!pngCid) return;
    try {
      const blob = await fetchIpfsBlob(pngCid, derived.pngPath);
      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = toFileName(displayedMeta.student_name || derived.showName, "png", String(derived.n));
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch {
      alert("No se pudo descargar el PNG. Intenta de nuevo.");
    }
  }

  return (
    <div style={{ padding: 24, maxWidth: 1100, margin: "0 auto" }}>
      <h1 style={{ marginBottom: 12 }}>Buscar certificado</h1>
      {!loaded ? <div>Cargando nombres...</div> : null}

      <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
        <input
          type="text"
          placeholder="Escribe el nombre..."
          value={q}
          onChange={(e) => {
            setQ(e.target.value);
            setSuggestionsOpen(true);
          }}
          onFocus={() => setSuggestionsOpen(true)}
          onKeyDown={onKeyDown}
          style={{ flex: 1, padding: "12px 14px", border: "1px solid #d1d5db", fontSize: 16 }}
        />
        <button
          onClick={handleBuscar}
          style={{
            padding: "12px 20px",
            border: "1px solid #2563eb",
            background: "#2563eb",
            color: "#fff",
            fontSize: 16,
            cursor: "pointer",
          }}
        >
          Buscar
        </button>
      </div>

      {suggestionsOpen && suggestions.length > 0 ? (
        <div style={{ marginTop: 6, background: "#fff", border: "1px solid #e5e7eb", maxHeight: 320, overflowY: "auto" }}>
          {suggestions.map((s) => (
            <div
              key={`${s.batchId}:${s.key}`}
              onMouseDown={() => {
                setQ(s.display);
                setSelectedKey(s.key);
                setSelectedBatch(s.batchId);
                setSuggestionsOpen(false);
                setHasSearched(true);
              }}
              style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid #f3f4f6" }}
            >
              {s.display} <span style={{ color: "#6b7280" }}>({s.batchId})</span>
            </div>
          ))}
        </div>
      ) : null}

      <div style={{ marginTop: 10, color: "#6b7280" }}>
        {selectedKey ? (
          <span>
            Mostrando: <b>{stripExt(selectedKey)}</b> <span style={{ color: "#6b7280" }}>({selectedBatch})</span>
          </span>
        ) : hasSearched ? (
          <span style={{ color: "#b91c1c" }}>No encontré coincidencias para "{q}".</span>
        ) : q ? (
          "Escribe y presiona Buscar o elige de las sugerencias..."
        ) : null}
      </div>

      {derived && derived.ipfsPNG ? (
        <div style={{ marginTop: 16 }}>
          <NftCard
            imageCid={derived.pngCid}
            imagePath={derived.pngPath}
            badgeText={derived.badge}
            name={displayedMeta.name}
            student={displayedMeta.student_name}
            university={displayedMeta.university}
            course={displayedMeta.course}
            issueMonth={displayedMeta.issue_month}
            hours={displayedMeta.hours}
            location={displayedMeta.location}
            description={displayedMeta.description}
            attributes={displayedMeta.attributes || []}
            onDownloadPng={downloadPng}
            // Botones a la derecha: Descargar + Mint
            mintButton={<MintPngButton pngCid={derived.pngCid} pngPath={derived.pngPath} />}
          />

          {jsonErr ? <div style={{ marginTop: 8, color: "#b91c1c" }}>{jsonErr}</div> : null}
        </div>
      ) : null}
    </div>
  );
}
